import { OrderedMap, Map, fromJS } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';

export const createDefaultState = () =>
  fromJS({
    feedback: Map(),
    feedbackCount: null,
    isFetching: false,
    fetchError: null,
    isAllFetched: false,
    isHighlightFeedback: null,
    isDeletedFeedback: null
  });

const deleteFeedback = (state, payload) => {
  const getFeedbacks = state.get('feedback');
  return fromJS(getFeedbacks.toJS().filter(itm => itm.id !== payload.id));
};

const highlightFeed = (state, payload) => {
  const getFeedbacks = state.get('feedback');
  return fromJS(
    getFeedbacks.toJS().map(itm => {
      if (itm.id === payload.id) {
        return {
          ...itm,
          isHighlighted: !payload.message.includes('de-highlighted')
        };
      }
      return itm;
    })
  );
};

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();
    case constants.FETCH_FEEDBACK:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_FEEDBACK_DONE:
      return state
        .set('feedback', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false)
        .set('isAllFetched', true);
    case constants.FETCH_FEEDBACK_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.HIGHLIGHT_FEEDBACK:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.HIGHLIGHT_FEEDBACK_DONE:
      return state
        .set('feedback', highlightFeed(state, payload))
        .set('isHighlightFeedback', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false)
        .set('isAllFetched', true);
    case constants.HIGHLIGHT_FEEDBACK_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.DELETE_FEEDBACK:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.DELETE_FEEDBACK_DONE:
      return state
        .set('feedback', deleteFeedback(state, payload))
        .set('isDeletedFeedback', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false)
        .set('isAllFetched', true);
    case constants.DELETE_FEEDBACK_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.FETCH_FEEDBACK_COUNT:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_FEEDBACK_COUNT_DONE:
      return state
        .set('feedbackCount', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.FETCH_FEEDBACK_COUNT_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    default:
      return state;
  }
}
